import { render } from "./ChampionshipPage.vue?vue&type=template&id=38129ed9"
import script from "./ChampionshipPage.vue?vue&type=script&lang=js"
export * from "./ChampionshipPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__